import React from 'react';

function Spinner({ ...props }) {
  return (
    <div className={`spinner ${props.className ? props.className : ''}`} />
  );
}

export default Spinner;
